var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.to)?_c('router-link',{class:_vm.btnClass,attrs:{"to":{ name: _vm.to }}},[_vm._t("default")],2):_c('button',{class:_vm.btnClass,attrs:{"type":[ _vm.submit ? 'submit': 'button' ]}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }